export enum IBrandNotificationType {
  ANNOUNCMENTS = "ANNOUNCMENTS",
  order = "order",
}

export enum IBrandNotificationEvent {
  ANNOUNCMENT_CREATED = "ANNOUNCMENT_CREATED",
  created = "created",
}
